export enum NavigatorOs {
  Windows = 'windows',
  Mac = 'mac',
  Linux = 'linux',
  Unknown = 'unknown',
}

export function detectNavigatorOs(navigator?: Navigator) {
  if (!navigator) {
    return NavigatorOs.Unknown
  }
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('Win') !== -1) {
    return NavigatorOs.Windows
  }
  if (userAgent.indexOf('Mac') !== -1) {
    return NavigatorOs.Mac
  }
  if (
    userAgent.indexOf('X11') !== -1 ||
    userAgent.indexOf('Linux') !== -1
  ) {
    return NavigatorOs.Linux
  }
  return NavigatorOs.Unknown
}

export function useNavigatorOs() {
  return typeof window === 'undefined'
    ? NavigatorOs.Unknown
    : detectNavigatorOs(window.navigator)
}
